import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const CategoryCard = ({ category, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      data-testid={`category-card-${category.slug}`}
    >
      <Link to={`/shop/${category.slug}`} className="category-card block">
        <img
          src={category.image || 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800'}
          alt={category.name}
        />
        <div className="absolute bottom-0 left-0 right-0 p-6 z-20">
          <h3 className="font-serif text-2xl md:text-3xl text-white mb-1">
            {category.name}
          </h3>
          <p className="text-white/80 text-sm line-clamp-1">
            {category.description}
          </p>
        </div>
      </Link>
    </motion.div>
  );
};

export default CategoryCard;
